<template>
<div>
    <v-card>
        <v-container fluid grid-list-sm>
            <v-layout row wrap>
                <v-flex offset-xs1 xs10 offset-md2 md8 offset-sm2 sm8>
                    <v-flex color="#A6C307" class="text-xs-center">
                        <i style="color:rgb(166, 195, 7); font-size:60px;" class="fa fa-user-circle-o mb-4" aria-hidden="true"></i>
                        <!-- <v-icon>home</v-icon> -->
                    </v-flex>
                    <v-flex class="headline text-xs-center">{{ $t('message.success_title') }}</v-flex>
                    <v-flex class="light-blue--text text--darken-3 text-xs-center my-4">
                        {{ $t('message.success_msg', { fullName: fullName }) }}
                    </v-flex>
                    <!-- buttons -->
                    <!-- <v-flex  class="blue-grey--text text--lighten-1 my-4 text-xs-center"> {{ $t('message.contact_bank') }} </v-flex > -->

                    <v-btn block color="#A6C307" class="white--text my-4" @click="next">{{ $t('message.continue') }}</v-btn>

                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</div>
</template>

<script>
// import { EventBus } from './EventBus.js';

export default {
    name: 'Success',
    props: {
        fullName: { type: String, default: '' },
    },
    data() {
        return {
        }
    },
    methods: {
        next() {
            console.log('cerrar continue');
            this.$emit('cancel');
        },
    }
}
</script>
<style>
/* TODO: change px for rem */
.subheading {
    font-size: 12px !important;
}
</style>
